/* RO motion (v20): one quiet system on every page. Things below the fold rise in softly as they arrive,
   headlines come into focus, photos open from a rounded mask, the leaf plate grows from the stem up.
   Anything on screen at load stays as it is; nothing is hidden without JS, with reduced motion, or for bots. */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window) || navigator.webdriver) return;
  var PANELS = '.grade, .why, .ritual, .calc, .faq, .finale, .panel, .pv-sec, .ab .who, .ab .end, .cart-pick, .empty-pick';
  var HEADS = '.h2:not(.rv), .finale-title';
  var SKIP_IMG = '.hero, .gal, .pdp, .cl-split, .stage-frame, .mbar, .hdr, .ftr, .grind-tin, .shop';
  var fold = innerHeight * 0.92;
  var below = function (el) { var r = el.getBoundingClientRect(); return r.top > fold && r.height > 0; };
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('mo-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px' });
  var mark = function (el, kind) {
    if (el.hasAttribute('data-mo') || !below(el)) return;
    if (kind === 'rise' && el.parentElement.closest('[data-mo="rise"]')) return;   // one rise per block, not two stacked
    el.setAttribute('data-mo', kind);
    io.observe(el);
  };
  var run = function () {
    [].forEach.call(document.querySelectorAll(PANELS), function (el) { mark(el, 'rise'); });
    [].forEach.call(document.querySelectorAll(HEADS), function (el) { mark(el, 'focus'); });
    [].forEach.call(document.querySelectorAll('.pv-plate img'), function (el) { mark(el, 'grow'); });
    [].forEach.call(document.querySelectorAll('main img, section img'), function (el) {
      if (el.closest(SKIP_IMG) || el.closest('.pv-plate') || /tin/.test(el.getAttribute('src') || '')) return;
      var r = el.getBoundingClientRect();
      if (r.width >= 220 && r.height >= 220) mark(el, 'open');
    });
    // a reveal never waits for a scroll that already happened (anchor jumps, restored scroll)
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('[data-mo]:not(.mo-in)'), function (el) {
        if (el.getBoundingClientRect().bottom < 0) el.classList.add('mo-in');
      });
    }, 1200);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
